import SettingsPanel from "../components/SettingsPanel.jsx";

export default function SettingsPage() {
  return (
    <div className="container">
      <div className="crumb"><a href="#/">Overview</a><span className="sep">/</span>Settings</div>
      <div className="hero">
        <h1>Global settings</h1>
        <div className="sub">These rates drive every cost &amp; value calculation across the portfolio.</div>
      </div>
      <SettingsPanel/>
    </div>
  );
}
